import {studioInstant, studioMinutes} from "@/lib/studioCalendar";

// One compact row per half-hour start, independent of appointment duration.
export function calendarSlotGroups(items, timeZone) {
  const groups = new Map();
  [...items].filter(item=>Number.isFinite(+studioInstant(item.start)))
    .sort((a,b)=>studioInstant(a.start)-studioInstant(b.start)||String(a.id).localeCompare(String(b.id)))
    .forEach(item=>{
      const minute=Math.floor(studioMinutes(studioInstant(item.start),timeZone)/30)*30;
      if(!groups.has(minute))groups.set(minute,[]);
      groups.get(minute).push(item);
    });
  return [...groups].sort(([a],[b])=>a-b).map(([minute,items])=>({minute,items}));
}
